<template>
    <span v-if="matrixStationRoleCell.HasStartControlWarning">
        <TooltipComp
            :text="`${$tm('matrix.startcontroloutsidewindow')} 
        ${stationRole?.StartControlMin != null ? `${$tm('matrix.startcontrolmin')} ${stationRole.StartControlMin}  ${$tm('general.sec')}` : ''}
        ${stationRole?.StartControlMax != null ? `${$tm('matrix.startcontrolmax')} ${stationRole.StartControlMax}  ${$tm('general.sec')}` : ''}
        ${$tm('general.usedtime')} ${Math.floor((matrixStationRoleCell.RaceContestantTimeUsedTime ?? 0) / 1000)} ${$tm('general.sec')}
         `"
        >
            <IconComp
                family="fa-solid"
                icon="fa-person-running-fast"
                class="fs-5 text-pink-500"
            />
        </TooltipComp>
    </span>
</template>
<script setup lang="ts">
import { IconComp, TooltipComp } from '@/components';
import type MatrixStationRoleCell from '../../classes/MatrixStationRoleCell';
import { useEventCommonStoreRef } from '@/stores';

const props = defineProps<{ matrixStationRoleCell: MatrixStationRoleCell }>();

const { StationRoles } = useEventCommonStoreRef();
const stationRole = StationRoles.value.find((sr) => sr.ID === props.matrixStationRoleCell.StationRoleId);
</script>
